import styled from 'styled-components';
import OnClickOutside from 'sushiweb/HOC/OnClickOutside';
import ChevronDown from 'sushiweb/Icons/all/ChevronDown';
import ChevronUp from 'sushiweb/Icons/all/ChevronUp';
import grey from 'sushiweb/tokens/color/grey';
import red from 'sushiweb/tokens/color/red';
import white from 'sushiweb/tokens/color/white';

export const ReportFormWrapper = styled.div`
  width: 500px;
  margin: 1rem 0 0 0;
  background: ${white};
  border: 0.1rem solid ${grey.z200};
  padding: 2rem;
`;

export const ReportResponseStateWrapper = styled.div`
  width: 550px;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  h5 {
    font-weight: 500;
    margin-top: 2.8rem;
  }
  p {
    margin: 1rem 0 2.4rem;
    font-size: 1.6rem;
  }
`;

export const PollingStateWrapper = styled.div`
  height: auto;
  right: 0;
  padding: 4.4rem 4.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--coolgreycoolgrey-900, #293142);
`;

export const ReponseHeader = styled.div`
  display: flex;
  p {
    font-size: 1.7rem;
    font-family: Lexend-300;
  }
  h4 {
    font-size: 2.3rem;
    font-family: Lexend-400;
  }
`;

export const AlignItemsWrapper = styled.div`
  text-align: center;
`;

export const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const JustifyContentWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const PollingModalsSpinnerHolder = styled.div`
  width: 100%;
  height: 30vh;
  margin: auto;
`;

export const SpinnerWrapper = styled.div`
  margin-top: 10rem;
`;

export const DownloadButtonWrapper = styled.a`
  margin-top: 3.4rem;
`;

export const SubmitBtnWrapper = styled.div`
  margin-top: 3.4rem;
`;

export const ReportModalBtnStyle = {
  background: red.z50,
  border: `0px solid ${red.z100}`,
  borderRadius: '12px',
  color: red.z500,
  fontWeight: 600,
  fontSize: '14px',
};

export const ReportModalBtnStyleRed = {
  border: `0px solid ${red.z100}`,
  borderRadius: '12px',
  fontWeight: 600,
  fontSize: '14px',
};

export const ReportModalFooter = styled.div`
  padding: 2rem 2.4rem;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  margin-top: -3rem;
  background: ${grey.z200};
  border-radius: 0px 0px 5px 5px;
  h4 {
    color: ${grey.z700};
    font-size: 1.6rem;
    font-weight: 800;
  }
}`;

export const DropdownWrapper = styled.div`
  margin-top: 5px;

  @media (max-width: 480px) {
    div > div > div > div {
      max-width: 20rem;
      overflow: ellipsis;
      margin: 0;
    }
  }

  @media (max-width: 360px) {
    div > div > div > div {
      max-width: 14rem;
    }
  }
`;

export const CreateButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  padding: 20px;
`;

export const SelectItemsContainer = styled(OnClickOutside)`
  position: relative;
  width: 100%;
  height: 5rem;
  top: -15px;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0.9rem 1.4rem;
  cursor: pointer;
  p {
    font-size: 1.6rem;
    color: ${grey.z800};
    margin-left: 0.8rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  &:hover {
    background: ${grey.z100};
  }
`;

export const CheckedBox = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${red.z500};
`;

export const CustomDropdown = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background: ${white};
  width: 100%;
  height: 100%;
  border: 0.1rem solid ${grey.z300};
  border-radius: 0.6rem;
  cursor: pointer;
  padding: 0 1.2rem;
  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1.8rem !important;
    color: ${({ dark }) => (!dark ? grey.z400 : grey.z800)} !important;
    font-weight: 300;
  }
`;

export const DropdownHeaderWrapper = styled.div`
  width: 100%;
`;

export const DropdownOptions = styled.div`
  position: absolute;
  top: 5.3rem;
  left: 0px;
  width: 100%;
  height: max-content;
  padding: 0.4rem 0;
  border-radius: 0.6rem;
  background: ${white};
  box-shadow: 0px 1px 8px rgb(28 28 28 / 15%);
  z-index: 10;
  overflow: hidden;
  p {
    margin-bottom: 0 !important; // required to center the content
  }
`;

DropdownOptions.Groups = styled.div`
  width: 100%;
  height: max-content;
  max-height: 19rem;
  padding-bottom: 5rem;
  overflow-y: scroll;
`;

export const StyledChevronDown = styled(ChevronDown)`
  position: absolute;
  right: 1.2rem;
`;

export const StyledChevronUp = styled(ChevronUp)`
  position: absolute;
  right: 1.2rem;
`;

export const UncheckedBox = styled.div`
  min-width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.4rem;
  background: ${white};
  border: 0.1rem solid ${props => (!props.disabled ? grey.z600 : grey.z400)};
`;
